<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Update Leave Application</h3>
           </template>
           <div class="row">
             <div class="col-md-6">
              <nav>
                 <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                       <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                       <router-link to="/hr/absenceleave">Leave & Absences Record</router-link>
                    </li>
                    <li class="breadcrumb-item active">Update Leave Application</li>
                 </ol>
              </nav>
              </div>
              <div class="col-md-6" style="margin-top:-45px">
                  <span class="float-right">
                    <h2>
                        <span class="badge badge-pill badge-danger">
                            {{credits_indicator.leave_credit_balance}}
                         </span>
                         Leave Credits 
                    </h2>
                  </span> 
              </div> 
           </div>
           <hr style="margin-top:-10px"/>
           <form @submit="formSubmit">
              <div class="row">
                 <div class="col-md-12">
                    <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Employee Leave Form</font>         
                    <div class="border-box-leave">
                       <div class="row">
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>Employee</label>
                                  <input v-model="item.full_name" class="form-control" disabled>
                               </div>
                             <div class="form-group"> 
                                <label>Date Filled  :</label>
                                <input type="date" v-model="item.date_filled" class="form-control" >
                               
                             </div>
                             <div class="form-group">
                                <label>Number of Days Leave :</label>
                                <input v-model="countDate" class="form-control"  readonly>
                             </div>
                             <div class="form-group">
                                <label>Type Of Leave : </label>
                                <select class="form-control" v-model="item.leave_type">
                                   <option value="">-- Please select one --</option>
                                   <option value="Vacation">Vacation Leave</option>
                                   <option value="Medical/Sick">Medical/Sick Leave</option>
                                   <option value="Emergency">Emergency Leave</option>
                                   <option value="Maternity">Maternity Leave</option>
                                   <option value="Paternity">Paternity Leave</option>
                                   <option value="Offset">Offset</option>
                                </select>
                             </div>
                             <div class="form-group">
                                <label>Remarks : </label>
                                <select class="form-control" v-model="item.remarks">
                                   <option disabled value="">-- Please select one --</option>
                                   <option value="With Pay">With Pay</option>
                                   <option value="Without Pay">Without Pay</option>
                                </select>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group"> 
                                <label>Start Date  :</label>
                                <input type="date" v-model="item.start_date" class="form-control">
                             </div>
                             <div class="form-group"> 
                                <label>End Date  :</label>
                                <input type="date" v-model="item.end_date" class="form-control">
                             </div>
                             <div class="form-group">
                                <label>Reason for Leave / Absent : </label>
                                <textarea rows="8" v-model="item.reason" class="form-control"></textarea>
                             </div>
                          </div>
                       </div>
                    </div>
                    <br/> <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Approval Status</font>  
                    <div class="border-box-leave">
                       <div class="row">
                          <div class="col-md-4">
                             <label>Supervisor Approval</label>
                             <select class="form-control" v-model="item.tl_status">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                          </div>
                          <div class="col-md-4">
                             <label>Departamental Head Approval</label>
                             <select class="form-control" v-model="item.asm_status">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                          </div>
                          <div class="col-md-4">
                             <label>HR Department Approval</label>
                             <select class="form-control" v-model="item.status">
                                <option value="">--Select One--</option>
                                <option value="pending">pending</option>
                                <option value="approved">approve</option>
                                <option value="rejected">rejected</option>
                             </select>
                          </div>
                       </div>
                       <hr/>
                       <div class="row">
                          <div class="col-md-4">
                             <label>Supervisor Date Approval</label>
                             <div class="form-group">
                                <input type="date" v-model="item.tl_date_approved" class="form-control">
                             </div>
                          </div>
                          <div class="col-md-4">
                             <label>Departamental Head Date Approval</label>
                             <div class="form-group">
                                <input type="date"  v-model="item.asm_date_approved" class="form-control"> 
                             </div>
                          </div>
                          <div class="col-md-4">
                             <label>HR Date Approval</label>
                             <div class="form-group">
                                <input type="date" v-model="item.hr_date_recived" class="form-control">
                             </div>
                          </div>
                       </div>
                    </div>
                    <div class="form-group">
                       <div class="float-right">  
                          <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Update Request</button> <br/><br/>
                       </div>
                    </div>
                    <br/> <br/>
                 </div>
              </div>
           </form>
        </card>
     </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      item:{},
      emp: "",
      no_of_days: "",
      // Errors handler
      error_handler: [],
      no_credits:'',
      //credits
       credits_indicator:'',
      //loading
      loading:true 
    };
  },
  mounted: function() {
    this.get_employees();
    this.leave_credits();
    this.getItem();
   setTimeout(() => {
           this.loading = false;
        }, 300); 
  },
  methods: {
    getItem() {
      axios
        .get("api/leaveabsences/get/" + this.$route.params.id)
        .then(response => {
          this.item = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    leave_credits(){
           axios
               .get('api/employee/credits/' + this.item.employee_id)
               .then(resp => {
                     this.credits_indicator = resp.data
               })
               .catch(error => {
                    console.log(error)
               })
    },
   
    get_employees() {
      axios
        .get("api/employees")
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formSubmit(e) {
      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(isConfirm => {
        if (isConfirm === true) {
          axios
            .post(
              "api/manualleave/add",
              {
                // employee_id: this.emp,
                // date_filled: this.date_filled,
                // no_of_days: this.no_of_days,
                // leave_type: this.leave_type,
                // remarks: this.remarks,
                // start_date: this.start_date,
                // end_date: this.end_date,
                // reason: this.reason,
                // status: this.status,
                // tl_status: this.tl_status,
                // asm_status: this.asm_status,
                // tl_date_approved: this.tl_date_approved,
                // asm_date_approved: this.asm_date_approved,
                // hr_date_approved: this.hr_date_approved
                
              }
            )
            .then(resp => {
              this.$swal("Save", "You successfully save this file", "success");
              this.$router.push({ name: "absence-leave" });
              this.resForm();
            })
            .catch(error => {
                  if (error.response.status == 422){
                        this.error_handler = error.response.data.errors 
                        this.no_credits = error.response.data.message
                        this.$swal('Opps', this.no_credits, 'error');

                        this.no_of_days = ''
                    }
                }); 
        }
      });
    }
  },
  computed:{  
  countDate:{
          get(){
              
              let start = moment(this.start_date)
              let end = moment(this.end_date)
              this.no_of_days = end.diff(start, "days") + 1
              //if NaN result change to 0
              if (isNaN(this.no_of_days )) this.no_of_days  = 0;
              return  this.no_of_days
          },

          set(val){
               this.no_of_days = val
          }
      }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-update-leave.vue